import Screen from '@screen';
import styled from 'styled-components';

const ChannelListProgressBarContainer = styled.div<React.CSSProperties>`
  bottom: ${80 * Screen.widthRatio}px;
  position: absolute;
  width: 100%;
`;

export default ChannelListProgressBarContainer;
